const Status = ({ status, active = true }) => {
  let styles = {
    OVER_DUE: "bg-red-500",
    PREPARE_PAYMENT: "bg-orange-500",
    PARTIALLY_PAID: "bg-teal-500",
    FULLY_PAID: "bg-green-500",
    PENDING: "bg-blue-600",
    PASS: "bg-green-500",
    FAIL: "bg-red-600",
    DRAFT: "bg-gray-500",
    WAITING_TO_CONFIRM: "bg-teal-500",
    HANDLED: "bg-sky-700",
    CANCELED: "bg-red-600",

    SELF_ASSESSMENT: "bg-teal-500",
    REVIEWING: "bg-indigo-500",
    IMPROVING: "bg-orange-500",
    COMPLETED: "bg-sky-700",

    DONE: "bg-blue-500",
    ASSIGNED: "bg-teal-500",
    AWAITING_PRODUCTION: "bg-pink-500",
    PLANNING: "bg-indigo-500 dark:bg-indigo-800",

    PURCHASE: "bg-green-500",
    未交付: "bg-red-500",
    部分交付: "bg-yellow-500",
    已交付: "bg-green-500",
    已全部交付: "bg-green-500",

    草稿: "bg-gray-500",
    已发送: "bg-blue-500",
    已确认: "bg-green-500",
    已完成: "bg-sky-700",
    已取消: "bg-red-600",
  };

  if (!status) return " - ";

  const style = styles[status.toUpperCase()] || "bg-gray-500";

  const statusString = status.replaceAll("_", " ").toLowerCase();

  return (
    <span
      className={`text-xs rounded-full inline-block text-gray-100 px-4 py-1 scale-90 capitalize whitespace-nowrap ${style} ${active ? "" : " opacity-40"}`}
    >
      {statusString}
    </span>
  );
};

export default Status;
